import { ORDER_APIS } from "@/api_framework/api_config";
import {
  IValidateMedicineExpiryRequest,
  IValidateMedicineExpiryResponse,
} from "@/api_framework/api_modals/Orders";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import axios, { AxiosError } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";

AxiosCurlirize(axios, () => {});

type IValidateMedicineExpiryResult = {
  status: boolean;
  message: string;
  data?: unknown;
  isRepeat?: boolean;
};

export const useValidateMedicineExpiryAPI = () => {
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (payload: IValidateMedicineExpiryRequest): Promise<IValidateMedicineExpiryResult> => {
      try {
        const endpoint = ORDER_APIS?.VALIDATE_MEDICINE_EXPIRY?.baseURL;
        if (!endpoint) {
          return { status: false, message: "Medicine expiry validation endpoint is missing" };
        }

        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

        const res = await axios.post<IValidateMedicineExpiryResponse>(endpoint, payload, {
          headers: {
            Authorization: accessToken ?? "",
            "Content-Type": "application/json",
          },
        });

        return {
          status: Boolean(res?.data?.status),
          message: res?.data?.message ?? "",
          data: res?.data?.data,
          isRepeat: Boolean((res?.data as any)?.is_repeat ?? (res?.data?.data as any)?.is_repeat),
        };
      } catch (error: unknown) {
        const axiosError = error as AxiosError<IValidateMedicineExpiryResponse>;
        sendCurl(axiosError?.config?.["curlCommand"]);

        const message = axiosError?.response?.data?.message || axiosError?.message || "Expiry validation failed";
        toast.error(message);
        return { status: false, message };
      }
    },
    [configuration, sendCurl],
  );

  return { execute };
};
